import React from 'react';
import useLegalPage from '../../hooks/useLegalPage';
import LegalPageLayout from '../../components/legal/LegalPageLayout';

const CookiePolicyPage = () => {
  const { page, loading, error, refetch } = useLegalPage('cookie-policy');

  return (
    <LegalPageLayout
      page={page}
      loading={loading}
      error={error}
      onRetry={refetch}
    />
  );
};

export default CookiePolicyPage;
